import { Checkbox, type CheckboxProps, Form } from 'antd';
import type { ReactNode } from 'react';

interface CustomFormCheckBoxProps extends CheckboxProps {
  label?: ReactNode;
  checkBoxClass?: string;
  dataTestId?: string;
}

const FormCheckBox = ({
  label = false,
  checkBoxClass = 'form-checkbox',
  name,
  className,
  checked = undefined,
  onChange = undefined,
  disabled,
  indeterminate = false,
  dataTestId,
}: CustomFormCheckBoxProps) => {
  return (
    <Form.Item name={name} className={`${className}`} valuePropName="checked" data-testid={dataTestId}>
      {label ? (
        <Checkbox
          id={name}
          className={`${checkBoxClass || ''}`}
          {...(checked !== undefined ? { checked } : {})}
          {...(onChange !== undefined ? { onChange } : {})}
          disabled={disabled}
          indeterminate={indeterminate}
        >
          {label}
        </Checkbox>
      ) : (
        <Checkbox
          id={name}
          className={`${checkBoxClass}`}
          {...(checked !== undefined ? { checked } : {})}
          {...(onChange !== undefined ? { onChange } : {})}
          disabled={disabled}
        />
      )}
    </Form.Item>
  );
};

export default FormCheckBox;
